import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	Grid,
	Typography
} from '@material-ui/core';
import AutofillV3 from 'components/Wrappers/materialUIWrappers/components/AutofillV3';
import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import { GetUserId, GetUserToken } from 'helpers/UserHelper';
import _ from 'lodash';
import { AssistantsSearch } from 'queries/assistant/queries';
import { ClientsSearch } from 'queries/clients/queries';
import { Todo } from 'queries/todo/mutations';
import React from 'react';
import { graphql, Query } from 'react-apollo';
import { showSnack } from 'reducers/NotificationReducer';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import store from 'store';
import DayMonthYear from 'components/Wrappers/materialUIWrappers/components/DayMonthYear';
import {
	dateValid,
	isEmptyOrSpaces,
	required
} from 'helpers/ValidationHelpers';

const max25 = value =>
	!value ? undefined : value.length < 26 ? undefined : 'Max 25 characters';
const max120 = value =>
	!value ? undefined : value.length < 121 ? undefined : 'Max 55 characters';

const charMin3 = value =>
	isEmptyOrSpaces(value)
		? undefined
		: value.length > 2
		? undefined
		: 'Must be at least 3 characters';

const initialState = {
	checkValidation: false,
	client_id: null,
	client_fullname: '',
	assigned_userId: null,
	assigned_user_fullname: '',
	editMode: false,
	loadingSubmit: false
};

class TodoDialog extends React.Component {
	state = {
		...initialState
	};

	componentDidMount() {
		if (this.props.todo && (this.props.todo.id || this.props.todo.client_id)) {
			this.props.initialize({
				...this.props.todo
			});

			this.setState({ ...this.props.todo, editMode: true });
		}
	}

	componentWillUnmount() {
		this.resetState();
	}

	resetState = () => {
		this.setState({
			initialState
		});
	};

	clientSearchTextChanged = (event, refetch) => {
		if (event && event.target) {
			this.setState({ client_fullname: event.target.value, client_id: null });
			refetch();
		}
	};

	clientSelected = (displayText, id, refetch) => {
		this.setState({
			client_id: parseInt(atob(id).split(':')[1], 10),
			client_fullname: displayText
		});
		refetch();
	};

	assistantSearchTextChanged = (event, refetch) => {
		if (event && event.target) {
			this.setState({
				assigned_user_fullname: event.target.value,
				assigned_userId: null
			});
			refetch();
		}
	};

	assistantSelected = (displayText, id, refetch) => {
		this.setState({
			assigned_userId: parseInt(id, 10),
			assigned_user_fullname: displayText
		});
		refetch();
	};

	onSubmit = () => {
		if (store.getState().form.todo.syncErrors) {
			store.dispatch(
				showSnack({
					message: 'Invalid Information',
					color: 'danger'
				})
			);
			return;
		}
		this.setState({ loadingSubmit: true });

		const todo = _.get(store.getState().form.todo, 'values');

		const input = {
			userId: GetUserId(),
			token: GetUserToken(),
			title: todo.title,
			desc: todo.desc,
			assistantId: this.state.assigned_userId,
			clientId: this.state.client_id,
			todoId:
				this.state.editMode && this.props.todo.id ? this.props.todo.id : null,
			dueDate: todo.due_date
		};

		this.props
			.Todo({
				variables: {
					input
				}
			})
			.then(resp => {
				if (this.state.editMode && this.props.todo.id) {
					this.props.todoEdited(resp.data.Todo);
				} else {
					this.props.todoAdded(resp.data.Todo);
				}
				this.props.closeDialog();
				this.setState({ loadingSubmit: false });
				store.dispatch(
					showSnack({
						message:
							this.state.editMode && this.props.todo.id
								? 'Todo Updated'
								: 'Todo Added',
						color: 'success'
					})
				);
			})
			.catch(error => {
				this.setState({ loadingSubmit: false });
				console.log('err', error);
			});
	};

	render() {
		return (
			<Dialog
				open={this.props.open}
				onClose={this.props.closeDialog}
				className="centerFixedDialog"
			>
				{this.state.loadingSubmit ? null : (
					<DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
						{this.state.editMode ? 'Edit' : 'Add'} To Do
					</DialogTitle>
				)}
				<DialogContent>
					{this.state.loadingSubmit ? (
						<div style={{ textAlign: 'center' }}>
							<Typography style={{ marginBottom: '15px' }}>
								Saving...
							</Typography>
							<CircularProgress size={25} />
						</div>
					) : (
						<Grid container>
							<Grid item xs={12} sm={12} style={{ marginTop: '20px' }}>
								<FormControl fullWidth>
									<Field
										component={FormInput}
										name="title"
										label="Title"
										isrequired={true}
										validate={[required, max25]}
										checkValidation={this.state.checkValidation}
									/>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={12} style={{ marginTop: '20px' }}>
								<FormControl fullWidth>
									<Field
										component={FormInput}
										name="desc"
										label="Description"
										isrequired={true}
										validate={[max120]}
										checkValidation={this.state.checkValidation}
									/>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={12} style={{ marginTop: '20px' }}>
								<FormControl fullWidth>
									<Field
										component={DayMonthYear}
										name="due_date"
										label="Due Date"
										placeholder="DD/MM/YYYY"
										checkValidation={this.state.checkValidation}
										validate={[dateValid]}
									/>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={12} style={{ marginTop: '20px' }}>
								<Query
									query={AssistantsSearch}
									variables={{
										brokerId: GetUserId(),
										search:
											this.state.assigned_user_fullname.length > 2
												? this.state.assigned_user_fullname
												: ''
									}}
									fetchPolicy="network-only"
								>
									{({ loading, error, data, refetch }) => {
										return (
											<Field
												label="Assign To (Optional)"
												name={'assigned_user_fullname'}
												component={AutofillV3}
												validate={[charMin3]}
												onItemSelect={(displayText, id) =>
													this.assistantSelected(displayText, id, refetch)
												}
												//textChanged={() => this.props.toggleOccupationValid(false)}
												autoFillList={
													!loading && data.AssistantsSearch
														? data.AssistantsSearch
														: []
												}
												loading={loading}
												listName={'Assistants'}
												zIndex={1000}
												displayText={'full_name'}
												subText={'email'}
												onChange={e =>
													this.assistantSearchTextChanged(e, refetch)
												}
											/>
										);
									}}
								</Query>
							</Grid>
							<Grid item xs={12} sm={12} style={{ marginTop: '20px' }}>
								<Query
									query={ClientsSearch}
									variables={{
										brokerId: GetUserId(),
										token: GetUserToken(),
										search:
											this.state.client_fullname.length > 2
												? this.state.client_fullname
												: ''
									}}
									fetchPolicy="network-only"
								>
									{({ loading, error, data, refetch }) => {
										return (
											<Field
												label="Client (Optional)"
												name={'client_fullname'}
												component={AutofillV3}
												validate={[charMin3]}
												onItemSelect={(displayText, id) =>
													this.clientSelected(displayText, id, refetch)
												}
												//textChanged={() => this.props.toggleOccupationValid(false)}
												autoFillList={
													!loading && data.ClientsSearch
														? data.ClientsSearch
														: []
												}
												loading={loading}
												listName={'Clients'}
												zIndex={1000}
												displayText={'full_name'}
												subText={'scd_email'}
												onChange={e => this.clientSearchTextChanged(e, refetch)}
											/>
										);
									}}
								</Query>
							</Grid>
							{this.state.loading ? (
								<Grid
									item
									xs={12}
									sm={12}
									style={{ textAlign: 'center', margin: '40px 0px 0px' }}
								>
									<CircularProgress color="secondary" size={30} />
								</Grid>
							) : null}
						</Grid>
					)}
				</DialogContent>
				{this.state.loadingSubmit ? null : (
					<DialogActions>
						<Button color="primary" onClick={this.props.closeDialog}>
							Cancel
						</Button>
						<Button color="primary" onClick={this.onSubmit}>
							{this.state.editMode ? 'Save' : 'Add'}
						</Button>
					</DialogActions>
				)}
			</Dialog>
		);
	}
}

TodoDialog = reduxForm({
	form: 'todo',
	destroyOnUnmount: true
})(TodoDialog);

TodoDialog = compose(graphql(Todo, { name: 'Todo' }))(TodoDialog);

export default TodoDialog;



// WEBPACK FOOTER //
// ./src/views/Todos/components/TodoDialog.jsx